import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ServiceSummaryTranslationKey, ServiceType } from '../../../../utils/services-summary.utils';

/*
 * Used to show the summary for products others than Seats. Products
 * that have a simple way to show the summary as a comma separated
 * list of items that sometimes have a quantity */
@Component({
  selector: 'fin-included-product-item-summary-other',
  templateUrl: './included-product-item-summary-other.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IncludedProductItemSummaryOtherComponent {
  @Input()
  summary: ServiceSummaryTranslationKey[];

  @Input()
  bodyClass = 'font-body-2';

  readonly ServiceType = ServiceType;
}
